import locale from "@bonliva-crm/locale";
import {
  ConsultantEventLog_GetEvents,
  ConsultantQuality_GetConsultantNew,
  ConsultantQualityItemEditor_SetOrdered
} from "@graphql";
import { QualityCheckButton } from "../quality-check-button";
import { QualityCheck, QualityCheckProps } from "../quality-check";
import { useRequestSent } from "../use-request-sent";
import { getDisabledQualityCheckButton } from "../utils/disabled-button-utils";

export const ivoNames = ["IVO-Grund", "IVO-Uppdatering"];

export function IvoQualityCheck(props: QualityCheckProps) {
  if (!ivoNames.includes(props.data.Name)) {
    throw new Error("Wrong component");
  }

  const { data, consultantData } = props;

  const { onRequestSent, loading } = useRequestSent({
    data,
    consultantData,
    requestFn: (todo) =>
      ConsultantQualityItemEditor_SetOrdered.func(
        {
          consultantId: consultantData._id,
          country: data.Country,
          qualityCheckName: data.Name,
          setOn: new Date(),
          todo
        },
        {
          refetchQueries: [
            ConsultantEventLog_GetEvents.OperationName,
            ConsultantQuality_GetConsultantNew.OperationName
          ]
        }
      )
  });

  const disabledResult = getDisabledQualityCheckButton({
    data,
    consultantData,
    options: ["ivo-grund-approved", "no-ssn"]
  });

  const isDisabled = loading || disabledResult.isDisabled;

  return (
    <QualityCheck
      renderExtraAction={() => (
        <QualityCheckButton
          text={locale.Order}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            onRequestSent();
          }}
          disabled={isDisabled}
          loading={loading}
          disabledInfo={disabledResult.disabledInfo}
        />
      )}
      {...props}
    />
  );
}
